import { UPDATE_AUTH, UPDATE_LOGOUT_REDUCER } from 'store/actionTypes';
import { ActionType, AuthModal } from 'utils/modals';

const AuthReducer = (state: AuthModal = new AuthModal(), action: ActionType) => {
    switch (action.type) {
        case UPDATE_AUTH:
            return { ...state, ...action.payload };
        case UPDATE_LOGOUT_REDUCER:
            return new AuthModal();
        default:
            return state;
    }
};

export default AuthReducer;
